<template>
  <!-- 返回上一页按钮 -->
  <div class="backToPre">
    <img class="backImg" src="../static/img/left.png" alt="" @click="backPre">
    <div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HelloWorld',
    components: {},
    methods: {
      backPre() {
        this.$router.go(-1);
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .backToPre {
    height: 2.35rem;
    width: 100%;
    position: relative;
    line-height: 2.35rem;
    text-align: center;
    /* font-size: 0.8rem; */
    font-size: 0.85rem;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    background-color: #ffffff;

  }

  .backImg {
    width: 0.43rem;
    height: 0.85rem;
    position: absolute;
    top: 50%;
    margin-top: -0.42rem;
    left: 0.64rem;
  }
</style>